function ensureEventRegistered(event, events) {
  if (!events[event]) {
    throw new Error(`Unregistered event: ${event}`)
  }
}

export default class EventBus {
  constructor(params = {}) {
    this.events = {}
    this.index = 0
    this.subscriptions = []
    this.debug = !!params.debug
  }

  init({events}) {
    events = events || []

    events.forEach((event) => {
      this.registerEvent(event)
    })

    return this
  }

  registerEvent(event) {
    this.events[event] = event
  }

  publish({event, data = {}}) {
    if (this.debug) {
      console.debug(`Publishing event: '${event}' with data:`)
      console.dir(data)
    }

    ensureEventRegistered(event, this.events)

    const subscribers = this.subscriptions.filter((subscription) => {
      return subscription.event === event
    })

    subscribers.forEach((subscriber) => {
      subscriber.callback.call(subscriber.context, data)
    })
  }

  subscribe({event, callback, context = this}) {
    ensureEventRegistered(event, this.events)

    const id = this.index++

    const subscription = {
      id,
      event,
      callback,
      context,
      cancel: () => {
        this.subscriptions = this.subscriptions.filter((sub) => {
          return sub.id !== id
        })

        return subscription
      }
    }

    this.subscriptions.push(subscription)

    return subscription
  }
}
